import { Controller } from "@hotwired/stimulus";

export default class NotificationValidatorController extends Controller {
  static targets = [
    "handledOnField",
    "oneMonthCheckbox",
    "oneMonthLabel",
    "twoWeekCheckbox",
    "twoWeekLabel",
    "specificDateCheckbox",
    "specificDateLabel",
    "specificDateField",
    "warningMessage",
  ];

  declare readonly handledOnFieldTarget: HTMLInputElement;
  declare readonly oneMonthCheckboxTarget: HTMLInputElement;
  declare readonly oneMonthLabelTarget: HTMLLabelElement;
  declare readonly twoWeekCheckboxTarget: HTMLInputElement;
  declare readonly twoWeekLabelTarget: HTMLLabelElement;
  declare readonly specificDateCheckboxTarget: HTMLInputElement;
  declare readonly specificDateLabelTarget: HTMLLabelElement;
  declare readonly specificDateFieldTarget: HTMLInputElement;
  declare readonly warningMessageTargets: HTMLElement[];

  connect(): void {
    this.validateNotifications();
  }

  validateNotifications(): void {
    const handledOnValue = this.handledOnFieldTarget.value;
    if (!handledOnValue) return;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // 1ヶ月前通知（前月1日）の確認
    const oneMonthBeforeDate = new Date(handledOnValue);
    oneMonthBeforeDate.setMonth(oneMonthBeforeDate.getMonth() - 1);
    oneMonthBeforeDate.setDate(1);
    this.toggleCheckbox(this.oneMonthCheckboxTarget, this.oneMonthLabelTarget, oneMonthBeforeDate, today, 0);

    // 2週間前通知の確認
    const twoWeekBeforeDate = new Date(handledOnValue);
    twoWeekBeforeDate.setDate(twoWeekBeforeDate.getDate() - 14);
    this.toggleCheckbox(this.twoWeekCheckboxTarget, this.twoWeekLabelTarget, twoWeekBeforeDate, today, 1);

    // 任意日通知は日付が選択されている場合のみチェック
    this.validateSpecificDate();
  }

  validateSpecificDate(): void {
    const specificDateValue = this.specificDateFieldTarget.value;
    if (!specificDateValue) return;

    const specificDate = new Date(specificDateValue);
    if (!specificDate) return;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    this.toggleCheckbox(this.specificDateCheckboxTarget, this.specificDateLabelTarget, specificDate, today, 2);
  }

  private toggleCheckbox(
    checkbox: HTMLInputElement,
    label: HTMLLabelElement,
    notificationDate: Date,
    today: Date,
    warningIndex: number,
  ): void {
    const isPast = notificationDate < today;

    if (isPast) {
      checkbox.disabled = true;
      checkbox.checked = false;
      label.classList.add("opacity-50", "cursor-not-allowed");
      label.classList.remove("cursor-pointer");

      if (this.warningMessageTargets[warningIndex]) {
        this.warningMessageTargets[warningIndex].classList.remove("hidden");
      }
    } else {
      checkbox.disabled = false;
      label.classList.remove("opacity-50", "cursor-not-allowed");
      label.classList.add("cursor-pointer");

      if (this.warningMessageTargets[warningIndex]) {
        this.warningMessageTargets[warningIndex].classList.add("hidden");
      }
    }
  }
}
